// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.poolsmobility.wallet",
    name: "poolswallet",
    homepage: "https://wallet.poolsmobility.com/",
    image_id: "1bd15c9e-cd7c-48e2-af7d-47fda2236600",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/pools-wallet/id6446882533",
        android: "https://play.google.com/store/apps/details?id=com.wallet.pools&hl=en_US",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "poolswallet://deeplink.poolsmobility.com",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map